import { gql } from '@apollo/client';

export const CREATE_NSC_PROGRESSION_DATAS = gql`
  mutation createNSCProgressionDatas($inputs: [CreateNSCProgressionDataInput!]!) {
    progressions: createNSCProgressionDatas(inputs: $inputs) {
      id
    }
  }
`;
